// ----------------------------------------------------------------------

export function emptyRows(page, rowsPerPage, arrayLength) {
  return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - arrayLength) : 0;
}

function descendingComparator(a, b, orderBy) {
  const valA = normalizeValue(a[orderBy]);
  const valB = normalizeValue(b[orderBy]);
  // console.log(valA, valB);
  if (valB < valA) return -1;
  if (valB > valA) return 1;
  return 0;
}

export const fSinceJoin = (date) => {
  if (!date) return '-';

  const start = new Date(date);
  const now = new Date();

  // Hitung selisih Tahun dan Bulan
  let years = now.getFullYear() - start.getFullYear();
  let months = now.getMonth() - start.getMonth();
  
  // Koreksi jika tanggal hari ini belum melewati tanggal bergabung di bulan ini
  if (now.getDate() < start.getDate()) {
    months -= 1;
  }

  // Koreksi jika hasil bulan negatif
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Jika sudah mencapai minimal 1 bulan
  if (years > 0 || months > 0) {
    const parts = [];
    if (years > 0) parts.push(`${years} Year${years > 1 ? 's' : ''}`);
    if (months > 0) parts.push(`${months} Month${months > 1 ? 's' : ''}`);
    return parts.join(' ');
  }

  // Jika kurang dari 1 bulan, hitung selisih Hari
  const diffInMs = now - start;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  // Jika benar-benar baru (kurang dari 24 jam)
  if (diffInDays < 1) {
    return 'Recently Joined';
  }

  // Jika sudah 1 hari atau lebih (tapi belum sebulan)
  return `${diffInDays} Day${diffInDays > 1 ? 's' : ''}`;
};

export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// 🔹 Helper: ubah string format menjadi angka murni bila perlu
// function normalizeValue(value) {
//   if (typeof value === 'string') {
//     // Hilangkan simbol uang dan titik pemisah ribuan
//     const numeric = value.replace(/[^\d.-]/g, '');
//     const parsed = parseFloat(numeric);
//     if (!isNaN(parsed)) return parsed;
//     return value.toLowerCase();
//   }
//   if (typeof value === 'number') return value;
//   return value ?? '';
// }

// ✅ ENHANCED: Detect common date formats from formatTime utils
function normalizeValue(value) {
  // Handle null/undefined
  if (value == null) return '';

  // ✅ Handle Date objects
  if (value instanceof Date) {
    return value.getTime(); // Convert to timestamp for comparison
  }

  // ✅ Handle string
  if (typeof value === 'string') {
    const trimmed = value.trim();

    // Check if it's a date string (ISO format: YYYY-MM-DD, YYYY-MM-DD HH:mm:ss, etc)
    const dateFormats = [
      /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
      /^\d{4}-\d{2}-\d{2}T/, // ISO 8601
      /^\d{4}-\d{2}-\d{2}\s/, // YYYY-MM-DD HH:mm:ss
      /^\d{2}\/\d{2}\/\d{4}/, // DD/MM/YYYY or MM/DD/YYYY
    ];

    const isDateString = dateFormats.some((regex) => regex.test(trimmed));
    if (isDateString) {
      const parsed = new Date(trimmed);
      if (!isNaN(parsed.getTime())) {
        return parsed.getTime(); // Return timestamp
      }
    }

    // Check if it's a currency/number string (e.g., "Rp 1.000.000", "1,234.56")
    const numericString = trimmed.replace(/[^\d.-]/g, ''); // Remove non-numeric except dot and minus
    const parsed = parseFloat(numericString);
    if (!isNaN(parsed) && numericString !== '') {
      return parsed;
    }

    // Return lowercase string for text comparison
    return trimmed.toLowerCase();
  }

  // ✅ Handle number
  if (typeof value === 'number') {
    return value;
  }

  // ✅ Handle boolean
  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }

  // ✅ Fallback
  return String(value).toLowerCase();
}
